import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useOrgaoOrigem = () => {
  const [orgaoOrigem, setOrgaoOrigem] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchOrgaoOrigem = async () => {
      try {
        const response = await httpClient.get(`/api/users/orgaoorigem`);

        // Transforma os dados da API para o formato esperado
        const options = response.data.map(
          (orgaoOrigem: { value: number; label: string }) => ({
            value: orgaoOrigem.value.toString(),
            label: orgaoOrigem.label,
          }),
        );
        setOrgaoOrigem(options);
      } catch (error) {
        console.error('Erro ao buscar dados de órgão de origem.', error);
      }
    };

    fetchOrgaoOrigem();
  }, []);

  return orgaoOrigem;
};
